<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area score">
      <div class="tit_area">
        <div class="sub_tit">사업 실적</div>
        <div class="sub_txt">
          인간을 위한 건축 / 미래를 향한 건축기술을 만들어 나갑니다.
        </div>
      </div>
    </div>
    <!--// sub title -->

    <t-toggle @change="onChangeTab" :activateIndex="activateTabIdx">
      <div class="tab_area">
        <div class="tab_item">
          <t-toggle-button href="#" tag="a" onClass="active" hash="#tab1"
            >PC 실적</t-toggle-button
          >
          <t-toggle-button href="#" tag="a" onClass="active" hash="#tab2"
            >건축실적</t-toggle-button
          >
          <t-toggle-button href="#" tag="a" onClass="active" hash="#tab3"
            >시행사업</t-toggle-button
          >
        </div>
      </div>
      <!-- sub contents -->
      <div class="sub_contents">
        <!-- PC실적 -->
        <t-toggle-content onClass="active" :classes="['conbox']">
          <div
            class="score_item"
            v-toggle="{
              target: 'yearRef',
              selector: 'ul.year_list > li > a',
            }"
            @onInit="changeYear"
            @onChange="changeYear"
            ref="yearRef"
          >
            <div class="score_lft">
              <ul class="year_list">
                <li :class="{ active: yearAct === 0 }">
                  <a href="#none">2021<span>년</span></a>
                </li>
                <li :class="{ active: yearAct === 1 }">
                  <a href="#none">2020<span>년</span></a>
                </li>
                <li :class="{ active: yearAct === 2 }">
                  <a href="#none">2019<span>년</span></a>
                </li>
                <li :class="{ active: yearAct === 3 }">
                  <a href="#none">2018<span>년</span></a>
                </li>
                <li :class="{ active: yearAct === 4 }">
                  <a href="#none">2017<span>년</span></a>
                </li>
                <li :class="{ active: yearAct === 5 }">
                  <a href="#none">2016<span>년</span></a>
                </li>
                <li :class="{ active: yearAct === 6 }">
                  <a href="#none">2015~2008<span>년</span></a>
                </li>
              </ul>
            </div>
            <div class="score_rht">
              <div class="year_contents">
                <!-- 2021년도 -->
                <div :class="['year_conbox', { active: yearAct === 0 }]">
                  <h3>2021<span class="unit">년</span></h3>
                  <div class="tbl_ty01 align_td_cnt">
                    <table>
                      <caption>
                        2021년도 사업실적 정보
                      </caption>
                      <colgroup>
                        <col style="width: 35%" />
                        <col style="width: auto" />
                        <col style="width: 20%" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td>우미건설</td>
                          <td class="aLeft">파주운정2차 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>KCC건설</td>
                          <td class="aLeft">인천원창2 물류창고</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>KCC건설</td>
                          <td class="aLeft">인천항동7가 물류창고</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>금호건설</td>
                          <td class="aLeft">평택고덕A54 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>KCC건설</td>
                          <td class="aLeft">용인남사 물류창고</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">강릉자이 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">가평자이 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">평택지제 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">화성봉담 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>한양산업개발</td>
                          <td class="aLeft">인천오류동 물류창고</td>
                          <td>HCS</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- 2020년도 -->
                <div :class="['year_conbox', { active: yearAct === 1 }]">
                  <h3>2020<span class="unit">년</span></h3>
                  <div class="tbl_ty01 align_td_cnt">
                    <table>
                      <caption>
                        2020년도 사업실적 정보
                      </caption>
                      <colgroup>
                        <col style="width: 35%" />
                        <col style="width: auto" />
                        <col style="width: 20%" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td>케이세웅</td>
                          <td class="aLeft">신세계광주오포 물류창고</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>금호건설</td>
                          <td class="aLeft">대구다사역어울림 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>금호건설</td>
                          <td class="aLeft">군산나운2재건축 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>우림콘크리트</td>
                          <td class="aLeft">안산스마트로지스퀘어 물류창고</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>한신공영</td>
                          <td class="aLeft">인천검단AB5블럭 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>삼성물산</td>
                          <td class="aLeft">탕정제2지방산업단지 지상구조물</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>KCC건설</td>
                          <td class="aLeft">인천서구원창동 물류창고</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>한양산업개발</td>
                          <td class="aLeft">이천안평리 물류창고</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">고양덕은A6 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>한신공영</td>
                          <td class="aLeft">
                            아산탕정2-A15BL 지하주차장,아파트
                          </td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>대우건설</td>
                          <td class="aLeft">수원팔달8 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>한양</td>
                          <td class="aLeft">구리수택 옥상조형물</td>
                          <td>두겁</td>
                        </tr>
                        <tr>
                          <td>포스코건설</td>
                          <td class="aLeft">양지물류2차 물류창고</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>삼호</td>
                          <td class="aLeft">인천항동7가 물류창고</td>
                          <td>DMS</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">광주우산 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>금호건설</td>
                          <td class="aLeft">부산기장 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>시엘에스이엔지</td>
                          <td class="aLeft">과천약수교회 지상구조물</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>금호건설</td>
                          <td class="aLeft">전주효자 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>창성건설</td>
                          <td class="aLeft">평택팸스캠프 지상구조물</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>금호건설</td>
                          <td class="aLeft">청주율량 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>한양산업개발</td>
                          <td class="aLeft">이천소고리 지상구조물</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>한양산업개발</td>
                          <td class="aLeft">광주도척 지상구조물</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>현대건설</td>
                          <td class="aLeft">녹번역 옥상조형물</td>
                          <td>H/S</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">보라매자이 오픈발코니</td>
                          <td>오픈발코니</td>
                        </tr>
                        <tr>
                          <td>삼성물산</td>
                          <td class="aLeft">아산8라인 지상구조물</td>
                          <td>H/S</td>
                        </tr>
                        <tr>
                          <td>IS동서</td>
                          <td class="aLeft">양지C구역 지상구조물</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>현대ENG</td>
                          <td class="aLeft">하남미사 공동구 덮개 지상구조물</td>
                          <td>H/S</td>
                        </tr>
                        <tr>
                          <td>금호건설</td>
                          <td class="aLeft">양원지구 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- 2019년도 -->
                <div :class="['year_conbox', { active: yearAct === 2 }]">
                  <h3>2019<span class="unit">년</span></h3>
                  <div class="tbl_ty01 align_td_cnt">
                    <table>
                      <caption>
                        2019년도 사업실적 정보
                      </caption>
                      <colgroup>
                        <col style="width: 35%" />
                        <col style="width: auto" />
                        <col style="width: 20%" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td>금호건설</td>
                          <td class="aLeft">광주우산 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>한양</td>
                          <td class="aLeft">성남금광3 옥상조형물</td>
                          <td>H/S</td>
                        </tr>
                        <tr>
                          <td>금호건설</td>
                          <td class="aLeft">아산모종 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>한양산업개발</td>
                          <td class="aLeft">인천항동TJ물류 지상구조물</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>금호건설</td>
                          <td class="aLeft">인천남동오션뷰 지상구조물</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>포스코건설</td>
                          <td class="aLeft">청주수곡 옥상조형물</td>
                          <td>기둥</td>
                        </tr>
                        <tr>
                          <td>현대ENG</td>
                          <td class="aLeft">위례A3-4aBL 옥상조형물</td>
                          <td>H/S</td>
                        </tr>
                        <tr>
                          <td>영무건설</td>
                          <td class="aLeft">시흥장현 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>영무건설</td>
                          <td class="aLeft">대구평리 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>영무건설</td>
                          <td class="aLeft">광양마동 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>삼성물산</td>
                          <td class="aLeft">평택FAB2기덮개 지상구조물</td>
                          <td>H/S</td>
                        </tr>
                        <tr>
                          <td>동성건설</td>
                          <td class="aLeft">
                            부천신중동지식산업센터 지상구조물
                          </td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">서초방배오픈발코니 옥상조형물</td>
                          <td>오픈발코니</td>
                        </tr>
                        <tr>
                          <td>재성종합건설</td>
                          <td class="aLeft">천안모전리물류창고 지상구조물</td>
                          <td>RPS</td>
                        </tr>
                        <tr>
                          <td>한신공영</td>
                          <td class="aLeft">세종4-2P1 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>서희건설</td>
                          <td class="aLeft">남양주부평 지하주차장</td>
                          <td>JRS</td>
                        </tr>
                        <tr>
                          <td>금호건설</td>
                          <td class="aLeft">세종4-2M4BL 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>금호건설</td>
                          <td class="aLeft">다산지금 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>한양</td>
                          <td class="aLeft">구리수택 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>포스코건설</td>
                          <td class="aLeft">오산대역 옥상조형물</td>
                          <td>H/S</td>
                        </tr>
                        <tr>
                          <td>신동아건설</td>
                          <td class="aLeft">김포한강AA-12 주택</td>
                          <td>H/S</td>
                        </tr>
                        <tr>
                          <td>까뮤이앤씨</td>
                          <td class="aLeft">한라화성동탄C 지상구조물</td>
                          <td>RPS</td>
                        </tr>
                        <tr>
                          <td>기창건설</td>
                          <td class="aLeft">SK기흥ICT밸리 지상구조물</td>
                          <td>기둥</td>
                        </tr>
                        <tr>
                          <td>대우건설</td>
                          <td class="aLeft">과천주공6 옥상조형물</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>삼성물산</td>
                          <td class="aLeft">부천송내1-2 지하주차장</td>
                          <td>기둥, 보</td>
                        </tr>
                        <tr>
                          <td>지산</td>
                          <td class="aLeft">용인남사 지상구조물</td>
                          <td>보</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">일산식사3 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>까뮤이앤씨</td>
                          <td class="aLeft">시흥배곧 지상구조물</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">김포한강메트로자이 옥상조형물</td>
                          <td>H/S</td>
                        </tr>
                        <tr>
                          <td>삼성물산</td>
                          <td class="aLeft">부산온천2 지하주차장</td>
                          <td>기둥, 보</td>
                        </tr>
                        <tr>
                          <td>KCC건설</td>
                          <td class="aLeft">안성원곡 지상구조물</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">신반포자이 옥상조형물</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">과천주공6 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">다산지금 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">다산진건 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>삼성물산</td>
                          <td class="aLeft">상아2 지하주차장</td>
                          <td>기둥, 보</td>
                        </tr>
                        <tr>
                          <td>우미건설</td>
                          <td class="aLeft">경산하양 지하주차장/옥상조형물</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">위례포레자이 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>금호건설</td>
                          <td class="aLeft">인천검단 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- 2018년도 -->
                <div :class="['year_conbox', { active: yearAct === 3 }]">
                  <h3>2018<span class="unit">년</span></h3>
                  <div class="tbl_ty01 align_td_cnt">
                    <table>
                      <caption>
                        2018 사업실적 정보
                      </caption>
                      <colgroup>
                        <col style="width: 35%" />
                        <col style="width: auto" />
                        <col style="width: 20%" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td>KCC건설</td>
                          <td class="aLeft">안성죽산물류창고 지상구조물</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>KCC건설</td>
                          <td class="aLeft">이천마장 물류창고 지상구조물</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>우림콘크리트</td>
                          <td class="aLeft">
                            하남미사다인지식산업센터 지상구조물
                          </td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>삼성물산</td>
                          <td class="aLeft">신정2-1 지하주차장</td>
                          <td>MRS</td>
                        </tr>
                        <tr>
                          <td>포스코건설</td>
                          <td class="aLeft">청주수곡 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>금호건설</td>
                          <td class="aLeft">평택고덕 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">서초무지개 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>리젠시빌건설</td>
                          <td class="aLeft">이천마장A1 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>한양</td>
                          <td class="aLeft">구로항동 옥상조형물</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>한라</td>
                          <td class="aLeft">삼성전자평택주차빌딩 지상구조물</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">고덕자이6차 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>리젠시빌건설</td>
                          <td class="aLeft">이천마장A1 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>삼성ENG</td>
                          <td class="aLeft">평택2기 정수장 지상구조물</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>포스코건설</td>
                          <td class="aLeft">일산킨텍스 옥상조형물</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>삼성물산</td>
                          <td class="aLeft">서초우성1 지하주차장</td>
                          <td>MRS</td>
                        </tr>
                        <tr>
                          <td>포스코건설</td>
                          <td class="aLeft">인천도화 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">울산테크노 2B-1 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">울산테크노 2B-1 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>KCC건설</td>
                          <td class="aLeft">성남도촌 주택</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>제일건설</td>
                          <td class="aLeft">시흥장현 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>대우건설</td>
                          <td class="aLeft">과천주공7단지 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">안산발코니2차 옥상조형물</td>
                          <td>오픈발코니</td>
                        </tr>
                        <tr>
                          <td>SK건설</td>
                          <td class="aLeft">고덕지구 옥상조형물</td>
                          <td>Half-Slab</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">신촌자이 옥상조형물</td>
                          <td>오픈발코니</td>
                        </tr>
                        <tr>
                          <td>삼성물산</td>
                          <td class="aLeft">개포시영 지하주차장</td>
                          <td>MRS</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">시흥장현B8 지하주차장</td>
                          <td>Half-Slab</td>
                        </tr>
                        <tr>
                          <td>명관컨설팅</td>
                          <td class="aLeft">포일동 다세대 주택</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>포스코건설</td>
                          <td class="aLeft">평택지제2BL 지하주차장</td>
                          <td>기둥, 보</td>
                        </tr>
                        <tr>
                          <td>포스코건설</td>
                          <td class="aLeft">평택지제1BL 지하주차장</td>
                          <td>기둥, 보</td>
                        </tr>
                        <tr>
                          <td>금호건설</td>
                          <td class="aLeft">시흥장현 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>동성건설</td>
                          <td class="aLeft">
                            가좌G타워지식산업센터 지상구조물
                          </td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>금호건설</td>
                          <td class="aLeft">김포양곡B2/D1 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>KCC건설</td>
                          <td class="aLeft">이천F&amp;F 물류창고 지상구조물</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>중흥건설</td>
                          <td class="aLeft">진주혁신A6 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>대일산업</td>
                          <td class="aLeft">첨단 진아리채 지하주차장</td>
                          <td>기둥, 보</td>
                        </tr>
                        <tr>
                          <td>삼성물산</td>
                          <td class="aLeft">평택 FAB2기</td>
                          <td>보</td>
                        </tr>
                        <tr>
                          <td>삼성물산</td>
                          <td class="aLeft">평택 EUV2차</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>선경이엔씨</td>
                          <td class="aLeft">
                            휴매드 시화MTV 물류센터 지상구조물
                          </td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>신흥산업</td>
                          <td class="aLeft">
                            동진F&amp;C지식산업센터 지상구조물
                          </td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">부산명륜자이 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>삼성물산</td>
                          <td class="aLeft">가재울5 지하주차장</td>
                          <td>MRS</td>
                        </tr>
                        <tr>
                          <td>현대건설</td>
                          <td class="aLeft">고덕지구 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>금호건설</td>
                          <td class="aLeft">아산탕정 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">광주계림8구역 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>제이앤에스테크</td>
                          <td class="aLeft">부산산성터널풍도 지상구조물</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>한양</td>
                          <td class="aLeft">수원인계 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>삼성물산</td>
                          <td class="aLeft">평택 EUV 지상구조물</td>
                          <td>고감쇠</td>
                        </tr>
                        <tr>
                          <td>삼성물산</td>
                          <td class="aLeft">화성 E-PJT 지상구조물</td>
                          <td>고감쇠</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">신반포자이 옥상조형물</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">안산그랑시티자이 오픈발코니</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">이천마장2차 B4 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- 2017년도 -->
                <div :class="['year_conbox', { active: yearAct === 4 }]">
                  <h3>2017<span class="unit">년</span></h3>
                  <div class="tbl_ty01 align_td_cnt">
                    <table>
                      <caption>
                        2017년도 사업실적 정보
                      </caption>
                      <colgroup>
                        <col style="width: 35%" />
                        <col style="width: auto" />
                        <col style="width: 20%" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td>화성산업</td>
                          <td class="aLeft">운정지구 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>한양</td>
                          <td class="aLeft">울산송정 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>포스코건설</td>
                          <td class="aLeft">
                            서울복합발전소지하화공사 지상구조물
                          </td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">이천마장 1차 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>포스코건설</td>
                          <td class="aLeft">중이온가속기 지상구조물</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>한양</td>
                          <td class="aLeft">시흥은계 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">신반포센트럴자이 지하주차장</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>우미건설</td>
                          <td class="aLeft">전주효천 A2 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>금호산업</td>
                          <td class="aLeft">동해천곡 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>현대건설</td>
                          <td class="aLeft">
                            힐스테이트판교모비우스연결브릿지 지상구조물
                          </td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>태명실업</td>
                          <td class="aLeft">서안성물류센터 지상구조물</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>백광도시개발</td>
                          <td class="aLeft">SK보라매 오픈발코니</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">포항초곡 87-2 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>공명이엠씨</td>
                          <td class="aLeft">삼성화재 아산사옥 장비반입구</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>삼표피앤씨</td>
                          <td class="aLeft">SK하이닉스 지상구조물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>금호산업</td>
                          <td class="aLeft">수원호매실어울림 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">송도 3차 A2 옥상조형물</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>포스코대우</td>
                          <td class="aLeft">평창미디어숙소 지상구조물</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>동성건설</td>
                          <td class="aLeft">
                            대구성서드림타운지식산업센터 지상
                          </td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>서브원</td>
                          <td class="aLeft">판토스시화물류센터 지상구조물</td>
                          <td>RPS</td>
                        </tr>
                        <tr>
                          <td>금강종합건설</td>
                          <td class="aLeft">인천부평테크시티 지상구조물</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>대일산업</td>
                          <td class="aLeft">원주혁신도시C3 지하주차장</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">성남고등S2 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">LGD파주냉각탑증축 지상구조물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>공명이엠씨</td>
                          <td class="aLeft">
                            삼성화재아산사옥장비반입구 지상구조
                          </td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>중흥건설</td>
                          <td class="aLeft">구로항동 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>중흥건설</td>
                          <td class="aLeft">고양향동 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>금호건설</td>
                          <td class="aLeft">서산테크노밸리 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>포스코건설</td>
                          <td class="aLeft">용인기흥 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>포스코건설</td>
                          <td class="aLeft">평택소사벌 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>중흥토건</td>
                          <td class="aLeft">전주만성C2 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>중흥토건</td>
                          <td class="aLeft">시흥배곧B2 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>중흥토건</td>
                          <td class="aLeft">시흥목감B1 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>중흥토건</td>
                          <td class="aLeft">김해진영B1 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>한양</td>
                          <td class="aLeft">수원호매실 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>대림산업</td>
                          <td class="aLeft">고양로지스틱스 지상구조물</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>리젠시빌건설</td>
                          <td class="aLeft">진해남문5-2BL 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>삼성물산</td>
                          <td class="aLeft">장위5 지하주차장</td>
                          <td>MRS</td>
                        </tr>
                        <tr>
                          <td>KD건설</td>
                          <td class="aLeft">당목리 물류센터 지상구조물</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>우미건설</td>
                          <td class="aLeft">동탄주상복합1차 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>삼성물산</td>
                          <td class="aLeft">장위1 지하주차장</td>
                          <td>MRS</td>
                        </tr>
                        <tr>
                          <td>삼성물산</td>
                          <td class="aLeft">신반포18,24차 지하주차장</td>
                          <td>MRS</td>
                        </tr>
                        <tr>
                          <td>대우건설</td>
                          <td class="aLeft">남양주마석푸르지오 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">시흥목감5차B9 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">경산임당공동1 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">원주기업도시3-1BL 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">구미국가산단A26 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>SK건설</td>
                          <td class="aLeft">고덕지구 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>티에프이엔씨</td>
                          <td class="aLeft">포천열병합발전소 지상구조물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>대우건설</td>
                          <td class="aLeft">광주센트럴 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">원주기업도시3-2BL 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>중흥건설</td>
                          <td class="aLeft">진주혁신A12 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>선경이앤씨</td>
                          <td class="aLeft">팅크웨어 HCS 지상구조물</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>대우건설</td>
                          <td class="aLeft">고덕지구 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>화성산업</td>
                          <td class="aLeft">영종화성파크드림 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- 2016년도 -->
                <div :class="['year_conbox', { active: yearAct === 5 }]">
                  <h3>2016<span class="unit">년</span></h3>
                  <div class="tbl_ty01 align_td_cnt">
                    <table>
                      <caption>
                        2016년도 사업실적 정보
                      </caption>
                      <colgroup>
                        <col style="width: 30%" />
                        <col style="width: auto" />
                        <col style="width: 30%" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td>대우건설</td>
                          <td class="aLeft">김해율하 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">한류월드 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>대우건설</td>
                          <td class="aLeft">오산 푸르지오 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">고양향동1,2,3차 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>리젠시빌</td>
                          <td class="aLeft">양주옥정 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>소백종합건설</td>
                          <td class="aLeft">부천 남양인쇄 공장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>대우건설</td>
                          <td class="aLeft">부천오정물류센터</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>현대건설</td>
                          <td class="aLeft">현대자동차 연수원 천안</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">화성동탄A97BL 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>삼성물산</td>
                          <td class="aLeft">개포2 지하주차장</td>
                          <td>HCS,MRS</td>
                        </tr>
                        <tr>
                          <td>소백종합건설</td>
                          <td class="aLeft">부천 CK덴탈 공장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>소백종합건설</td>
                          <td class="aLeft">부천 태영전열 공장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>한양</td>
                          <td class="aLeft">안양박달 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>한양</td>
                          <td class="aLeft">김포고천 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>한양</td>
                          <td class="aLeft">이천증포 3,5BL 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>우일</td>
                          <td class="aLeft">남극세종기지 하계연구동</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>중흥건설</td>
                          <td class="aLeft">시흥목감B1 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>중흥건설</td>
                          <td class="aLeft">시흥배곧B2 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>우미건설</td>
                          <td class="aLeft">시흥은계 1,2차 지하주차장</td>
                          <td>1Way H/S</td>
                        </tr>
                        <tr>
                          <td>우미건설</td>
                          <td class="aLeft">안성용두 지하주차장</td>
                          <td>1Way H/S</td>
                        </tr>
                        <tr>
                          <td>CJ건설</td>
                          <td class="aLeft">광주 메가 허브 터미널</td>
                          <td>RPS</td>
                        </tr>
                        <tr>
                          <td>중흥건설</td>
                          <td class="aLeft">세종3-1M6 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">하남미사 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- 2015~2008년도 -->
                <div :class="['year_conbox', { active: yearAct === 6 }]">
                  <h3>2015~2008<span class="unit">년</span></h3>
                  <div class="tbl_ty01 align_td_cnt">
                    <table>
                      <caption>
                        2015~2008년도 사업실적 정보
                      </caption>
                      <colgroup>
                        <col style="width: 35%" />
                        <col style="width: auto" />
                        <col style="width: 20%" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">인천가정5 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>중흥건설</td>
                          <td class="aLeft">대구테크노A13 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">화성동탄A49 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">부천옥길C1 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>삼성엔지니어링</td>
                          <td class="aLeft">평택고덕 그린동 지상구조물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">경북도청2차 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>삼성물산</td>
                          <td class="aLeft">화성DSR C동 지상구조물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>한양</td>
                          <td class="aLeft">세종3-3L2 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>대성건설</td>
                          <td class="aLeft">인천가정 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">경북도청1차 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>중흥건설</td>
                          <td class="aLeft">세종2-1M2 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>중흥건설</td>
                          <td class="aLeft">세종2-1L2 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">의정부민락3차 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">의정부민락2차 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">수원광교A6 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>한양</td>
                          <td class="aLeft">시흥논곡 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">위례A2-2 지하주차장</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">고양원흥 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">인천서창 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">의정부민락1차 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">시흥배곧3차 B11 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>한양</td>
                          <td class="aLeft">성내미주 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>중흥건설</td>
                          <td class="aLeft">부산명지 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">화성동탄A41 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">수원호매실B5 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">송도2차 RC1 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>동문건설</td>
                          <td class="aLeft">천안신부 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>포스코건설</td>
                          <td class="aLeft">위례 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>현대엔지니어링</td>
                          <td class="aLeft">위례2차 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">수원호매실B9 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">시흥목감B7 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">시흥목감B4 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>화성산업</td>
                          <td class="aLeft">대구침산 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>중흥건설</td>
                          <td class="aLeft">평택소사벌 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">아산탕정복합1 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">오산세교D1 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">아산탕정1-A6 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">부산명지B6 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>포스코건설</td>
                          <td class="aLeft">위례C1-4 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>한양</td>
                          <td class="aLeft">평택청북 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>중흥건설</td>
                          <td class="aLeft">세종 M6 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>SK건설</td>
                          <td class="aLeft">이천 하이닉스 반도체 지상구조물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">송도RC4 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>중흥건설</td>
                          <td class="aLeft">나주B10 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">시흥배곧B9 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>대성건설</td>
                          <td class="aLeft">대구옥포 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>한양</td>
                          <td class="aLeft">세종1-2 M4 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>우미건설</td>
                          <td class="aLeft">평택소사벌 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>중흥건설</td>
                          <td class="aLeft">나주B14 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>중흥건설</td>
                          <td class="aLeft">세종3-2 M4 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>중흥건설</td>
                          <td class="aLeft">전주C3 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>중흥건설</td>
                          <td class="aLeft">나주B15 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">월남2-1BL 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">아산탕정A8 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">춘천거두 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">전북혁신C6 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">전북혁신C5 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">안동센트럴자이 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>엠코</td>
                          <td class="aLeft">위례신도시A3-6a 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">대구테크노A15 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">부산명지 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>한화건설</td>
                          <td class="aLeft">동탄A21 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">신금호 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>진아건설</td>
                          <td class="aLeft">대구달성 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>진흥기업</td>
                          <td class="aLeft">광주 다목적 경기장</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>중흥건설</td>
                          <td class="aLeft">세종M1 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>한양</td>
                          <td class="aLeft">세종1-1 M3 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>대우건설</td>
                          <td class="aLeft">부산센텀 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>SK건설</td>
                          <td class="aLeft">인천용현2BL 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">순천오천A1 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>동부건설</td>
                          <td class="aLeft">수원야구장증축 경기장</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>엠코</td>
                          <td class="aLeft">위례신도시 A3-7블럭 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>동일토건</td>
                          <td class="aLeft">용곡3,4단지 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">광주월남 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>한양</td>
                          <td class="aLeft">세종시M3 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>한양</td>
                          <td class="aLeft">세종시M7 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">세종시M4 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">세종시L8 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">가재울 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">화성동탄A30 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>SK건설</td>
                          <td class="aLeft">가재울 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>SK건설</td>
                          <td class="aLeft">시흥배곧 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>SK건설</td>
                          <td class="aLeft">신동탄 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">세종시L2 1-3 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>우미건설</td>
                          <td class="aLeft">전주혁신B12 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>우미건설</td>
                          <td class="aLeft">전주혁신B2 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">시흥군자B8 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">안동옥동3 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">화성동탄A22 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">울산혁신C2 지하주차장</td>
                          <td>MIR</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">공덕자이 지하주차장</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">영등포아트자이 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">세종시 M6,L2BL 지하주차장</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">전북혁신도시C7BL 지하주차장</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>포스코건설</td>
                          <td class="aLeft">송도 더샾그린스퀘어 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>㈜한양,울트라건설</td>
                          <td class="aLeft">세곡2지구 4단지 지하주차장</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">대구신천자이 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">송림경기장 경기장</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>㈜한양</td>
                          <td class="aLeft">세종시 M7 지하주차장</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>㈜한양</td>
                          <td class="aLeft">세종시 M3 지하주차장</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>㈜한양</td>
                          <td class="aLeft">첨단2지구 지하주차장</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">울산무거 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>대우조선해양건설</td>
                          <td class="aLeft">마곡지구 지하주차장</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">첨단2지구 A8BL 지하주차장</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">첨단2지구 A4BL 지하주차장</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>한라건설</td>
                          <td class="aLeft">김포한강신도시 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>엠코</td>
                          <td class="aLeft">상도엠코타운 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">
                            광주제석산 호반힐하임 지하주차장
                          </td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>호반베르디움</td>
                          <td class="aLeft">전주혁신도시B11BL 지하주차장</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">해운대자이 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">대전도안 지하주차장</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>동부건설</td>
                          <td class="aLeft">안성농식품 물류센터</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>경남기업</td>
                          <td class="aLeft">김포신도시 조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>우미건설</td>
                          <td class="aLeft">남양주별내 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>SK건설</td>
                          <td class="aLeft">수원 SK Sky VIEW PC외장재</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">강서자이 지하주차장</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">울산무거 지하주차장</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>LS산전</td>
                          <td class="aLeft">유유물류센터 지상구조물</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">광주첨단자이 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>선경이엔씨</td>
                          <td class="aLeft">오크라인 이천물류센터</td>
                          <td>MTS</td>
                        </tr>
                        <tr>
                          <td>한라건설</td>
                          <td class="aLeft">김포신도시 지하주차장</td>
                          <td>Ribbed Slab</td>
                        </tr>
                        <tr>
                          <td>현대건설</td>
                          <td class="aLeft">김포신도시 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>㈜한양</td>
                          <td class="aLeft">광교신도시 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>현대건설</td>
                          <td class="aLeft">광장동 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>㈜한양</td>
                          <td class="aLeft">청라지구 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>한라건설</td>
                          <td class="aLeft">청주용정 지하주차장</td>
                          <td>Ribbed Slab</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">금호자이 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>선경이엔씨</td>
                          <td class="aLeft">덕평물류센터</td>
                          <td>MTS</td>
                        </tr>
                        <tr>
                          <td>태영건설</td>
                          <td class="aLeft">태영하이원 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>현대건설</td>
                          <td class="aLeft">현대해운대 지하주차장</td>
                          <td>DTS</td>
                        </tr>
                        <tr>
                          <td>㈜한양</td>
                          <td class="aLeft">파주교하 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>삼성물산</td>
                          <td class="aLeft">화성 반도체 공장</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>쌍용건설</td>
                          <td class="aLeft">김포 옥탑조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>서브원</td>
                          <td class="aLeft">LG디스플레이 지하주차장</td>
                          <td>HCS</td>
                        </tr>
                        <tr>
                          <td>호반건설</td>
                          <td class="aLeft">김포 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>신명종합건설</td>
                          <td class="aLeft">영종도 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">연지자이 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>대우건설</td>
                          <td class="aLeft">대구 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>우미건설</td>
                          <td class="aLeft">영종도 지하주차장</td>
                          <td>Ribbed Slab</td>
                        </tr>
                        <tr>
                          <td>쌍용건설</td>
                          <td class="aLeft">부산구서 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">무학자이 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>제일건설</td>
                          <td class="aLeft">청라 지하주차장</td>
                          <td>MTS</td>
                        </tr>
                        <tr>
                          <td>현대건설</td>
                          <td class="aLeft">고양 체육관</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>포유이엔지</td>
                          <td class="aLeft">홍익대 MHS보</td>
                          <td>MHS</td>
                        </tr>
                        <tr>
                          <td>선경이엔씨</td>
                          <td class="aLeft">일미물류 이천 물류센터</td>
                          <td>MHS</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">성복자이2차 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>화인종합건설</td>
                          <td class="aLeft">안성 축산종합타운 신축공사</td>
                          <td>기둥,보-데크 Slab</td>
                        </tr>
                        <tr>
                          <td>동원시스템즈</td>
                          <td class="aLeft">시화물류센타</td>
                          <td>DTS</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">성복자이1차 옥상조형물</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>쌍용건설</td>
                          <td class="aLeft">김포신도시Ab-14BL 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">구성자이 옥상조형물</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>SK건설</td>
                          <td class="aLeft">F1경주장</td>
                          <td>PC</td>
                        </tr>
                        <tr>
                          <td>현대건설</td>
                          <td class="aLeft">용인성복1차 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>대명건영</td>
                          <td class="aLeft">서교자이 MHS보</td>
                          <td>MHS</td>
                        </tr>
                        <tr>
                          <td>대우건설</td>
                          <td class="aLeft">용인동백아파트형공장</td>
                          <td>MTS</td>
                        </tr>
                        <tr>
                          <td>SK건설</td>
                          <td class="aLeft">부산오륙도중학교 지상층RC,PC</td>
                          <td>DTS</td>
                        </tr>
                        <tr>
                          <td>현대건설</td>
                          <td class="aLeft">인천검단3차1,2단지 지하주차장</td>
                          <td>Half Slab</td>
                        </tr>
                        <tr>
                          <td>엠코</td>
                          <td class="aLeft">고양터미널</td>
                          <td>기둥,보-데크 Slab</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </t-toggle-content>
        <!--// PC실적 -->

        <!-- 토목건축실적 -->
        <t-toggle-content onClass="active" :classes="['conbox']">
          <div class="score_item">
            <div class="score_lft">
              <ul class="year_list">
                <li class="active">
                  <a href="#none" class="cursor_default"
                    >2021~2007<span>년</span></a
                  >
                </li>
              </ul>
            </div>
            <div class="score_rht">
              <div class="year_contents">
                <!-- 2021~2008년도 -->
                <div class="year_conbox active">
                  <h3>2021~2007<span class="unit">년</span></h3>
                  <div class="tbl_ty01 align_td_cnt">
                    <table>
                      <caption>
                        2008년도 토목건축공사 정보
                      </caption>
                      <colgroup>
                        <col style="width: 30%" />
                        <col style="width: auto" />
                        <col style="width: 15%" />
                        <col style="width: 20%" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td>강북구청</td>
                          <td class="aLeft">삼양동공영주차장 리모델링공사</td>
                          <td>2020년</td>
                          <td>5.8억 원</td>
                        </tr>
                        <tr>
                          <td>LS ELECTRIC</td>
                          <td class="aLeft">영암태양광발전시설</td>
                          <td>2019년</td>
                          <td>67억 원</td>
                        </tr>
                        <tr>
                          <td>예스코</td>
                          <td class="aLeft">경기지사 남양주호평</td>
                          <td>2012년</td>
                          <td>33억 원</td>
                        </tr>
                        <tr>
                          <td>유유물류산업㈜</td>
                          <td class="aLeft">유유물류센터</td>
                          <td>2012년</td>
                          <td>736억 원</td>
                        </tr>
                        <tr>
                          <td>SIG개발</td>
                          <td class="aLeft">화도물류센터</td>
                          <td>2012년</td>
                          <td>461억 원</td>
                        </tr>
                        <tr>
                          <td>케이씨 플레닝</td>
                          <td class="aLeft">까치산 오거닉스</td>
                          <td>2008년</td>
                          <td>50억 원</td>
                        </tr>
                        <tr>
                          <td>대화화장품</td>
                          <td class="aLeft">신길동 오거닉스</td>
                          <td>2007년</td>
                          <td>31억 원</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </t-toggle-content>
        <!--// 토목건축실적 -->

        <!-- 시행사업 -->
        <t-toggle-content onClass="active" :classes="['conbox']">
          <div class="score_item">
            <div class="score_lft">
              <ul class="year_list">
                <li class="active">
                  <a href="#none" class="cursor_default"
                    >2021~2008<span>년</span></a
                  >
                </li>
              </ul>
            </div>
            <div class="score_rht">
              <div class="year_contents">
                <!-- 2021~2008년도 -->
                <div class="year_conbox active">
                  <h3>2021~2008<span class="unit">년</span></h3>
                  <div class="tbl_ty01 align_td_cnt">
                    <table>
                      <caption>
                        2021~2008년도 시행사업 정보
                      </caption>
                      <colgroup>
                        <col style="width: 30%" />
                        <col style="width: auto" />
                        <col style="width: 15%" />
                        <col style="width: 20%" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td>GS건설</td>
                          <td class="aLeft">GS 고양덕은 자이 아파트</td>
                          <td>2020년</td>
                          <td>4,282억 원</td>
                        </tr>
                        <tr>
                          <td>대우건설㈜</td>
                          <td class="aLeft">판교 푸르지오그랑블 아파트</td>
                          <td>2008년</td>
                          <td>3,400억 원</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </t-toggle-content>
        <!--// 시행사업 -->
      </div>
    </t-toggle>
    <!--// sub contents -->
  </div>
  <!--// container -->
</template>

<script>
import page from '@/mixins/page';

import { TToggle, TToggleButton, TToggleContent } from '@/components/TToggle';

export default {
  mixins    : [page],
  components: {
    TToggle,
    TToggleButton,
    TToggleContent
  },
  data() {
    return {
      isFixed       : false,
      activateTabIdx: 0,
      yearAct       : null
    };
  },
  methods: {
    onChangeTab({ act }) {
      this.activateTabIdx = act;

      if (this.isFixed) {
        window.scrollTo(0, this.$refs.visualRef.clientHeight);
      }
    },
    changeYear({ acts }) {
      this.yearAct = acts;
    }
  }
};
</script>

<style lang="scss" scoped></style>
